<script setup>

import { inject, onMounted, reactive, ref, computed, watch} from 'vue';
import Modal from '../../Modal.vue';
import { getAuth } from 'firebase/auth';
import { Firebase_App } from '../../firebase.js';
import { db, getDocumentById, getDocumentsWithPrefix, loadDocumentFromStore } from '../../firestore.js';
import Button from '../../components/Button.vue';
import { collection, doc, getDoc, getDocs, limit, orderBy, query, startAfter, where } from 'firebase/firestore';
import DiffViewer from '../../diff/DiffViewer.vue';
import * as Y from 'yjs';
import { generateHTML } from '@tiptap/core'

import { prosemirrorToYDoc, yDocToProsemirrorJSON } from 'y-prosemirror'; // helper abstraction
import { DOMSerializer } from 'prosemirror-model';
import { schema } from 'prosemirror-schema-basic';
import DocumentHistoryView from './DocumentHistoryView.vue';

const emit = defineEmits(['close']);

const activeDoc = inject('document')
const userInfo = inject('userInfo')
const threads = ref([])
const loading = ref(false)
const error = ref(null)

let lastVisible = null;

const history = ref([])

async function load() {

  try {
    loading.value = true
    error.value = null
    let {updates} = await loadDocumentFromStore('DocumentContent', activeDoc.value.id)
    if (updates && typeof(updates[0]) === 'string') {
      error.value = 'Document is in old format and being converted on the server. Try again later.'
      return;
    }
    history.value = updates.reverse()
  } catch (e) {
    error.value = "Error loading history from the server."
    console.error(e)
  } finally {
    loading.value = false
  }
}
watch(activeDoc, load, {
  immediate: true
})
</script>

<template>

<Modal style="max-width: 1000px;" title="Edit History" @close="() => emit('close')">
  <div v-if="loading">loading...</div>  
  <div v-else-if="error">{{error}}</div>    
  <DocumentHistoryView v-else :history="history"/>  
</Modal>  
  
</template>

<style scoped>

</style>